<template>
  <Modal :value="value" @hide="hide()" title="Share domain">
    <template slot="body">
      <p class="">
        Share domain <i>{{ domain.friendlyName }}</i> with another user account.
      </p>
      <p>
        Permissions for repositories only applies to built-in repositories. Each
        user gets their own authentication key.
      </p>

      <div class="margin-bottom-1">
        <BInput
          @valid="valid = $event"
          v-model="email"
          type="email"
          validation="required"
          placeholder="User email to share domain with"
          name="email"
          focus="true"
          @enter="save()"
        ></BInput>
      </div>

      <div class="columns is-unselectable">
        <div class="column is-6 content">
          <p>Domain permissions</p>

          <CheckboxText
            v-if="!domain.permission || domain.permission >= 4"
            :checked="selectedDomainPermission >= 4"
            @click="selectedDomainPermission = 4"
            tooltip="User can only browse."
            tooltipCss="has-tooltip-right"
            >Read</CheckboxText
          >

          <CheckboxText
            v-if="!domain.permission || domain.permission >= 8"
            :checked="selectedDomainPermission >= 8"
            @click="selectedDomainPermission = 8"
            tooltip="The above, and install/uninstall packages."
            tooltipCss="has-tooltip-right"
            >Execute</CheckboxText
          >

          <CheckboxText
            v-if="!domain.permission || domain.permission >= 16"
            :checked="selectedDomainPermission >= 16"
            @click="selectedDomainPermission = 16"
            tooltip="The above, and change existing items, e.g. renaming."
            tooltipCss="has-tooltip-right"
            >Change</CheckboxText
          >

          <CheckboxText
            v-if="!domain.permission || domain.permission >= 32"
            :checked="selectedDomainPermission >= 32"
            @click="selectedDomainPermission = 32"
            tooltip="The above, and create new items, e.g. add groups, generate/download new computer installer etc."
            tooltipCss="has-tooltip-right"
            >Add</CheckboxText
          >

          <CheckboxText
            v-if="!domain.permission || domain.permission >= 64"
            :checked="selectedDomainPermission >= 64"
            @click="selectedDomainPermission = 64"
            tooltip="The above, and remove items, like computers and groups. Also permission to use remote PowerShell."
            tooltipCss="has-tooltip-right"
            >Remove</CheckboxText
          >

          <CheckboxText
            v-if="!domain.permission || domain.permission >= 128"
            :checked="selectedDomainPermission >= 128"
            @click="selectedDomainPermission = 128"
            tooltip="The above, and remove the shared domain."
            tooltipCss="has-tooltip-right"
            >Remove domain</CheckboxText
          >

          <CheckboxText
            v-if="!domain.permission || domain.permission >= 256"
            :checked="selectedDomainPermission >= 256"
            @click="selectedDomainPermission = 256"
            tooltip="The above, and being able to edit shares, including sharing the domain with others."
            tooltipCss="has-tooltip-right"
            >Share domain</CheckboxText
          >
        </div>

        <div class="column is-6">
          <p>Repository permissions</p>

          <CheckboxText
            v-if="sourcePermission || sourcePermission >= 1"
            :checked="selectedSourcePermission >= 1"
            @click="selectedSourcePermission = 1"
            tooltip="Only able to browse the repo."
            >Read</CheckboxText
          >

          <CheckboxText
            v-if="!sourcePermission || sourcePermission >= 2"
            :checked="selectedSourcePermission >= 2"
            @click="selectedSourcePermission = 2"
            tooltip="The above, and download packages."
            >Download</CheckboxText
          >

          <CheckboxText
            v-if="!sourcePermission || sourcePermission >= 4"
            :checked="selectedSourcePermission >= 4"
            @click="selectedSourcePermission = 4"
            tooltip="The above, and update packages that already exists."
            >Update</CheckboxText
          >

          <CheckboxText
            v-if="!sourcePermission || sourcePermission >= 8"
            :checked="selectedSourcePermission >= 8"
            @click="selectedSourcePermission = 8"
            tooltip="The above, and add packages."
            >Create</CheckboxText
          >

          <CheckboxText
            v-if="!sourcePermission || sourcePermission >= 16"
            :checked="selectedSourcePermission >= 16"
            @click="selectedSourcePermission = 16"
            tooltip="The above, and delete packages."
            >Delete</CheckboxText
          >
        </div>
      </div>
    </template>
    <template slot="footer">
      <div v-if="!isLoading">
        <div
          @click="save()"
          :disabled="!valid"
          class="button is-success"
          :class="{ 'is-loading': isLoading }"
        >
          Save
        </div>
        <div class="button" @click="hide()">Cancel</div>
      </div>
      <div v-show="isLoading" class="spinner-wrapper center">
        <span class="spinner is-centered"></span>
      </div>
    </template>
  </Modal>
</template>
<script>
import { postApi } from "@/utils/http";

export default {
  props: {
    value: Boolean,
    title: String,
    domain: Object,
    sources: Array,
  },
  components: {
    IconText: () => import("@/components/singles/IconText.vue"),
    Modal: () => import("@/components/main/Modal.vue"),
    BInput: () => import("@/components/singles/BInput/component.vue"),
    CheckboxText: () => import("@/components/singles/CheckboxText.vue"),
  },
  data() {
    return {
      email: "",
      isLoading: false,
      selectedDomainPermission: 4,
      selectedSourcePermission: 1,
      sourcePermission: 0,
      valid: false,
    };
  },
  computed: {},
  created() {
    this.sourcePermission = this.sources.find((x) => !x.external).permission;
  },

  methods: {
    async save() {
      this.isLoading = true;
      const res = await postApi("set/shareDomain", {
        domainUID: this.domain.uid,
        mail: this.email.trim().toLowerCase(),
        domainPermission: this.selectedDomainPermission,
        sourcePermission: this.selectedSourcePermission,
      });

      this.isLoading = false;

      if (res.length !== 0) {
        this.$emit("change");
        this.hide();
      } else {
        this.$helpers.notify(
          "Not found",
          "The user does not exist.",
          "warning"
        );
      }
    },

    hide() {
      if (!this.isLoading) {
        this.$emit("hide", false);
        this.$emit("input", false);
      }
    },
  },
};
</script>
